import api from '@/api/api';

const state = {
    uploadRequests: [],
    requestDates: [],
    uploadRequestsForTarget: [],
    mtrNamesForTarget: [],
};

const getters = {
    uploadRequests: state => state.uploadRequests,
    requestDates: state => state.requestDates,
    uploadRequestsForTarget: state => state.uploadRequestsForTarget,
    currentUploadRequestById: state => id => {
        return state.uploadRequestsForTarget.find(item => item.id.toString() === id.toString());
    },
    mtrNamesForTarget: state => state.mtrNamesForTarget,
};

const mutations = {
    SET_UPLOAD_REQUESTS(state, uploadRequests) {
        state.uploadRequests = uploadRequests;
    },
    SET_REQUEST_DATES(state, requestDates) {
        state.requestDates = requestDates;
    },
    SET_UPLOAD_REQUESTS_FOR_TARGET(state, uploadRequestsForTarget) {
        state.uploadRequestsForTarget = uploadRequestsForTarget;
    },
    SET_MTR_NAMES_FOR_TARGET(state, mtrNamesForTarget) {
        state.mtrNamesForTarget = mtrNamesForTarget
    },
    CLEAR_UPLOAD_REQUESTS(state) {
        state.uploadRequests = [];
    },
    CLEAR_REQUEST_DATES(state) {
        state.requestDates = []
    },
    CLEAR_UPLOAD_REQUESTS_FOR_TARGET(state) {
        state.uploadRequestsForTarget = []
    },
};

const actions = {
    /**
     * Fetch all upload requests for targets and save it to state.
     * @return {Promise} result.
     */
    async fetchUploadRequests({ commit }, { filters }) {
        try {
            const {
                upload_requests, request_dates, target_builds, target_builds_count
            } = await api.xmlRequests.fetchRequestsForTargets({ filters });

            commit('SET_UPLOAD_REQUESTS', upload_requests);
            commit('SET_REQUEST_DATES', request_dates)
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS', target_builds, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS_TOTAL_COUNT', target_builds_count, { root: true });
        } catch (error) {
            return Promise.reject('Error of upload requests list fetching');
        }
    },
    /**
     * Fetch all upload requests for current targets and save it to state.
     * @return {Promise} result.
     */
    async fetchUploadRequestsForTarget({ commit }, { requestsDate, targetBuildId }) {
        try {
            const {
                target_build, upload_requests, mtr_names
            } = await api.xmlRequests.fetchRequestsForTargetAndDate(requestsDate, targetBuildId);

            commit('SET_UPLOAD_REQUESTS_FOR_TARGET', upload_requests);
            commit('TargetBuilds/ADD_TARGET_BUILD', target_build, { root: true });
            commit('SET_MTR_NAMES_FOR_TARGET', mtr_names)
        } catch (error) {
            return Promise.reject('Error of upload requests for target fetching');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}